'use client';

import { useContext } from 'react';
import { HeldError } from '@storefront/shared-components/error-information/held-error';
import { RetryableError } from '@storefront/shared-components/error-information/retryable-error';
import { FlagsContext } from '@storefront/context/LDFlagsContext';
import ErrorClientWrapper from './error-client-wrapper';
import ErrorClientWrapperVisID from '../v2/pdp-config/error.p';

type ErrorProps = {
  error: RetryableError | HeldError;
  resetErrorBoundary?: () => unknown;
};

export default function CustomError({ error }: Readonly<ErrorProps>) {
  const { enableVisID } = useContext(FlagsContext);

  return enableVisID ? (
    <ErrorClientWrapperVisID error={error} />
  ) : (
    <ErrorClientWrapper error={error} />
  );
}
